module.exports = __webpack_public_path__ + "assets/80217e6f0f16dc15b6028ee4e3a4a742.svg";